import {
  Grid,
  MenuItem,
  Button,
  TextField,
  Typography,
  Chip,
  AccordionSummary,
  AccordionDetails,
  Paper,
  Checkbox,
  FormControlLabel
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import { WarehouseDDL } from '../../components/Almacen'
import { ZoneDDL } from '../../components/Zone'
import { CreatedDateFilterComponent } from '../../components/_WMS/DateComponents/CreatedDateFilter'
import { PickingRouteAdminFilters, pickingRouteinitialFilters } from './config'
import { ModernLabel } from '../../components/_WMS/ModernLabel'
import { useTypesPickingRoute } from '../../hooks/useTypePickingRoute'
import { PickerFilter } from './PickerFilter'
import { ApiConfig } from '../../config/api'
import axios from 'axios'
import { useApi } from '../../hooks/useApi'
import { User } from '../../interfaces'
import { useOrderOrigins } from '../../hooks'
import { GenericDLL } from '../../components/Almacen/UI/GenericDLL'
import { PickerValidatorFilter } from './PickerValidatorFilter'
import Accordion from '@mui/material/Accordion'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

interface PickingRouteAdminSearchProps {
  initialFilters: PickingRouteAdminFilters
  setFilters: React.Dispatch<React.SetStateAction<PickingRouteAdminFilters>>
  handleSearch: () => void
  handleChange: (
    e: React.ChangeEvent<{
      name?: string
      value: unknown
    }>
  ) => void
}

const getUserList = () => {
  const url = new URL(`${ApiConfig.UserApi}/GetList`)

  return axios.get(url.toString())
}

export const PickingRouteAdminSearch: React.FC<
  PickingRouteAdminSearchProps
> = ({ handleSearch, initialFilters: filters, handleChange, setFilters }) => {
  const { state: usersState, callApi: userCallApi } = useApi<User[]>()
  const [pickingRouteState, setPickingRouteState] = useState(0)
  const [expanded, setExpanded] = useState(true)
  const [resetDates, setResetDates] = useState(false)
  const [disableFilterDate, setDisableFilterDate] = useState(false)
  const onSearchButtonClick = () => handleSearch()

  const [currentSku, setCurrentSku] = useState<string>('') // SKU temporal
  const [listSkuToSearch, setListSkuToSearch] = useState<string[]>(
    filters.skuId
  )

  const {
    getOrderOrigins,
    orderOriginsState: { orderOrigins }
  } = useOrderOrigins()

  const handleChangeExpandFilter = () => {
    setExpanded(!expanded)
  }

  const handleAddSku = () => {
    if (currentSku.trim() && !listSkuToSearch.includes(currentSku)) {
      const updatedSkus = [...listSkuToSearch, currentSku.trim()]
      setListSkuToSearch(updatedSkus) // Actualiza localmente
      handleChange({
        target: {
          name: 'skuId',
          value: updatedSkus
        }
      } as React.ChangeEvent<{ name: string; value: string[] }>)
      setCurrentSku('') // Limpia el campo de entrada
    }
  }

  const handleOnDeleteChipSKU = (sku: string) => {
    const updatedSkus = listSkuToSearch.filter((item) => item !== sku)
    setListSkuToSearch(updatedSkus) // Actualiza localmente
    handleChange({
      target: {
        name: 'skuId',
        value: updatedSkus
      }
    } as React.ChangeEvent<{ name: string; value: string[] }>)
  }

  const handleClear = () => {
    setListSkuToSearch([])
    setCurrentSku('')
    setPickingRouteState(0)
    setFilters(pickingRouteinitialFilters)
    setResetDates(!resetDates)
    setDisableFilterDate(false)
  }

  const {
    typesPickingRouteState: { typesPickingRoute }
  } = useTypesPickingRoute()

  const requestGetPickerUsersList = () => {
    userCallApi(getUserList())
  }

  useEffect(() => {
    if (orderOrigins?.length === 0) {
      getOrderOrigins()
    }

    requestGetPickerUsersList()
  }, [])

  const updatePickingRouteState = (state: number) => {
    const pickingRouteStateMappings: Record<
      number,
      { pickingRouteStateId: string; validationStatusId?: string }
    > = {
      1: { pickingRouteStateId: '1' },
      2: { pickingRouteStateId: '2' },
      3: { pickingRouteStateId: '3' },
      4: { pickingRouteStateId: '3', validationStatusId: '2' },
      5: { pickingRouteStateId: '3', validationStatusId: '3' }
    }

    const selectedState = pickingRouteStateMappings[state]

    if (selectedState) {
      updateFilter('pickingRouteStateId', selectedState.pickingRouteStateId)

      if (selectedState.validationStatusId) {
        updateFilter('validationStatusId', selectedState.validationStatusId)
      } else {
        // Si el estado es 1, 2 o 3, eliminamos validationStatusId
        removeFilter('validationStatusId')
      }
    }
  }

  const updateFilter = (name: string, value: string) => {
    handleChange({
      target: { name, value }
    } as React.ChangeEvent<{ name: string; value: string }>)
  }

  const handleOrderOrigin = (name: string, value: string) => {
    handleChange({
      target: { name, value }
    } as React.ChangeEvent<{ name: string; value: string }>)
  }

  // Nueva función para eliminar validationStatusId cuando no corresponde
  const removeFilter = (name: string) => {
    handleChange({
      target: { name, value: '' } // Se envía vacío para que no se aplique el filtro
    } as React.ChangeEvent<{ name: string; value: string }>)
  }

  useEffect(() => {
    updatePickingRouteState(pickingRouteState)
  }, [pickingRouteState])

  return (
    <Accordion expanded={expanded} onChange={handleChangeExpandFilter}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls='panel1bh-content'
        id='panel1bh-header'
      >
        <Typography>{expanded ? 'Ocultar' : 'Mostrar'} Filtros</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={2} direction='row'>
          {/* Primera Fila */}
          <Grid item xs={12} sm={6} md={3}>
            <ModernLabel label='Identificador de OT'>
              <TextField
                autoFocus
                tabIndex={1}
                type='number'
                variant='outlined'
                fullWidth
                label='Indicar orden de trabajo...'
                name='workOrderId'
                value={filters.workOrderId}
                onChange={handleChange}
              />
            </ModernLabel>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <ModernLabel label='Ruta de Picking'>
              <TextField
                tabIndex={2}
                variant='outlined'
                fullWidth
                label='Indicar ID de ruta...'
                name='pickingRouteId'
                type='number'
                value={filters.pickingRouteId}
                onChange={handleChange}
              />
            </ModernLabel>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <ModernLabel label='LPN (Taco/Tote)'>
              <TextField
                tabIndex={3}
                variant='outlined'
                fullWidth
                label='IndicarLPN - (Taco/Tote)'
                name='lpn'
                type='text'
                value={filters.lpn}
                onChange={handleChange}
              />
            </ModernLabel>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <ModernLabel label='ID de Pedido'>
              <TextField
                tabIndex={4}
                variant='outlined'
                fullWidth
                label='Indicar ID de Pedido'
                name='referenceId'
                type='text'
                value={filters.referenceId}
                onChange={handleChange}
              />
            </ModernLabel>
          </Grid>

          {/* Segunda Fila */}
          <Grid item xs={12} sm={6} md={3}>
            <ModernLabel label='Almacén'>
              <WarehouseDDL
                tabIndex={5}
                onChange={handleChange}
                value={filters.warehouseId}
                type='outlined'
              />
            </ModernLabel>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <ModernLabel label='Zona'>
              <ZoneDDL
                variant='outlined'
                value={filters.zoneId}
                onChange={handleChange}
                warehouseId={filters.warehouseId}
                disabled={filters.warehouseId <= 0}
              />
            </ModernLabel>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <ModernLabel label='Canal de Venta'>
              <GenericDLL
                tabIndex={7}
                initialValues={orderOrigins || []}
                onChange={(e) =>
                  handleOrderOrigin('orderOriginId', e.target.value.toString())
                }
                title='Canal de Venta'
                name='origin'
                valueKey={'orderOriginId'}
                value={filters.orderOriginId}
                variant='outlined'
              />
            </ModernLabel>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <ModernLabel label='Tipo de Ruta de Picking'>
              <TextField
                tabIndex={8}
                variant='outlined'
                id='typePickingRouteId'
                name='typePickingRouteId'
                select
                value={filters.typePickingRouteId}
                onChange={handleChange}
                fullWidth
              >
                {typesPickingRoute?.map(({ name, typePickingRouteId }) => (
                  <MenuItem value={typePickingRouteId}>{name}</MenuItem>
                ))}
              </TextField>
            </ModernLabel>
          </Grid>

          {/* Tercera Fila */}
          <Grid item xs={12} sm={6} md={3}>
            <ModernLabel label='Seleccionar estado de picking'>
              <TextField
                tabIndex={9}
                variant='outlined'
                id='pickingRouteStateId'
                name='pickingRouteStateId'
                select
                value={pickingRouteState}
                onChange={(e) => setPickingRouteState(parseInt(e.target.value))}
                fullWidth
              >
                <MenuItem value={0}>Seleccione Estado</MenuItem>
                <MenuItem value={1}>Creada</MenuItem>
                <MenuItem value={2}>Picking Iniciado</MenuItem>
                <MenuItem value={3}>Picking Finalizado</MenuItem>
                <MenuItem value={4}>En Validación</MenuItem>
                <MenuItem value={5}>Validada</MenuItem>
              </TextField>
            </ModernLabel>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <ModernLabel label='Seleccionar Pickeador'>
              <PickerFilter
                pickers={usersState.data || []}
                handleChange={handleChange}
                value={filters.pickerId}
              />
            </ModernLabel>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <ModernLabel label='Seleccionar Validador'>
              <PickerValidatorFilter
                pickers={usersState.data || []}
                handleChange={handleChange}
                value={filters.validationUserId}
              />
            </ModernLabel>
          </Grid>

          {/* Cuarta Fila */}
          <Grid item xs={12} md={6}>
            <ModernLabel label='SKUs contenidos'>
              <TextField
                variant='outlined'
                fullWidth
                label='Indicar SKUs contenidos en ruta de picking...'
                name='currentSku'
                value={currentSku}
                onChange={(e) => setCurrentSku(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault()
                    handleAddSku()
                  }
                }}
              />
            </ModernLabel>
            <div>
              {listSkuToSearch.map((item) => (
                <Chip
                  key={item}
                  label={item}
                  onDelete={() => handleOnDeleteChipSKU(item)}
                  style={{ margin: '5px' }}
                />
              ))}
            </div>
          </Grid>
          <Grid item xs={12} md={6}>
            <Paper
              variant='outlined'
              style={{
                width: '95%',
                padding: '20px 10px'
              }}
            >
              <Grid container alignItems='center' spacing={0}>
                <Grid item xs={3}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={!disableFilterDate}
                        value={!disableFilterDate}
                        onChange={() =>
                          setDisableFilterDate(!disableFilterDate)
                        }
                        name='chkRtv'
                        color='primary'
                      />
                    }
                    label='Incluir filtros'
                  />
                </Grid>
                <Grid item xs={9}>
                  <ModernLabel label='Fecha de creación'>
                    <CreatedDateFilterComponent
                      startDateValue={filters.initialDate}
                      finishDateValue={filters.endDate}
                      onChangeStartDate={(e) => handleChange(e)}
                      onChangeFinishDate={(e) => handleChange(e)}
                      resetDate={resetDates}
                      disabled={disableFilterDate}
                    />
                  </ModernLabel>
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          {/* Botones */}
          <Grid
            container
            item
            xs={12}
            justifyContent='flex-end'
            justify='flex-end'
            spacing={2}
          >
            <Grid item xs={12} sm={6} md={2}>
              <Button
                variant='contained'
                color='primary'
                onClick={onSearchButtonClick}
                fullWidth
              >
                Buscar
              </Button>
            </Grid>
            <Grid item xs={12} sm={6} md={1}>
              <Button
                variant='outlined'
                color='secondary'
                onClick={handleClear}
                fullWidth
              >
                Limpiar
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  )
}
